import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, Subject } from 'rxjs';

import { API_URL, AuthenticationRequest, AuthenticationResponse, RegisterUserRequest, UserInfoResponse } from '../../shared';
import { LocalService } from './local.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  readonly baseUrl: string;

  private logoutSource = new Subject();
  logoutSource$ = this.logoutSource.asObservable();
  private loginSource = new Subject();
  loginSource$ = this.loginSource.asObservable();

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient, private readonly _localService: LocalService) {
    this.baseUrl = `${this.apiUrl}/api/auth`;
  }

  public register(user: RegisterUserRequest): Observable<AuthenticationResponse> {
    return this.http.post<AuthenticationResponse>(`${this.baseUrl}/register`, user);
  }

  public authenticate(request: AuthenticationRequest): Observable<UserInfoResponse> {
    const headers = new HttpHeaders().set('skip-Error', 'true');
    return this.http.post<UserInfoResponse>(`${this.baseUrl}/authenticate`, request, { headers })
      .pipe(
        map((response: UserInfoResponse) => {
          this._localService.saveUser(response);
          this.loginSource.next(true);
          return response
        })
      );
  }

  public logout(): Observable<boolean> {    
    return this.http.post<boolean>(`${this.baseUrl}/logout`, {}).pipe(
      map((response: boolean) => {
        localStorage.clear();
        this.logoutSource.next(true);
        return response;
      })
    );
  }


  public refreshToken(): Observable<boolean> {
    const headers = new HttpHeaders().set('skip-Error', 'true'); 
    return this.http.post<boolean>(`${this.baseUrl}/refresh-token`, {}, {headers});
  }

}
